import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { APPOINTMENT_NAMESPACE } from '@/_store/appointment';
import { IAppointment } from '@/_store/types';
import { deepClone } from 'fast-json-patch';
import PropertyCardComponent from '@/components/property-card/PropertyCard.vue';
import ContactAppointmentMail from './MailTemplate/ContactAppointmentMail.vue';
import moment from 'moment';

@Component({
  components: {
    PropertyCardComponent,
    ContactAppointmentMail
  }
})
export default class ContactAppointment extends Vue {

  @Action('getAppointmentByObjectId', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointmentByObjectId!: (criteria: { objectId: string, key: string }) => Promise<void>;

  @Action('getProperty', { namespace: APPOINTMENT_NAMESPACE })
  private getPropertyAction!: (criteria: { objectId: string, key: string }) => Promise<any>;

  @Action('sendContactAppointment', { namespace: APPOINTMENT_NAMESPACE })
  private sendContactAppointment!: (criteria: { objectId: string, key: string, data: any, email: string }) => Promise<void>;

  @Getter('getAppointments', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointments!: IAppointment[];

  @Getter('getAppointmentByID', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointmentByID!: (id: string) => IAppointment;

  @Getter('getProperty', { namespace: APPOINTMENT_NAMESPACE })
  private getProperty!: any;

  @Getter('getStatusLoading', { namespace: APPOINTMENT_NAMESPACE })
  private getStatusLoading!: boolean;

  @Getter('getStatusSendFormLoading', { namespace: APPOINTMENT_NAMESPACE })
  private getStatusSendFormLoading!: boolean;

  @Getter('getStatusSendForm', { namespace: APPOINTMENT_NAMESPACE })
  private getStatusSendForm!: string;

  get buttonBackColor() {

    return '#' + this.$route.query.buttonBackColor || '';
  }

  get buttonFontColor() {
    return '#' + this.$route.query.buttonFontColor || '';
  }

  get font() {
    return this.$route.query.font || '';
  }

  get propertyPrice() {
    let price = '';
    if (this.getProperty) {
      price = this.getProperty.Price.toString();
      price = this.getProperty.ChargesRenter ? `<b>${this.getProperty.Price}</b> + <small>${this.getProperty.ChargesRenter} €</small> ${this.$t('CHARGES')}` : `${price} ‎€`;
      return price;
    }
    return '';
  }

  get propertyPicture() {
    if (this.getProperty) {
      if (this.getProperty.LargePicture) {
        return this.getProperty.LargePicture;
      }
      if (this.getProperty.MediumPicture) {
        return this.getProperty.MediumPicture;
      }
      if (this.getProperty.LargePictureItem) {
        return this.getProperty.LargePictureItem.Url;
      }
      if (this.getProperty.MediumPictureItem) {
        return this.getProperty.MediumPictureItem.Url;
      }
      if (this.getProperty.SmallPictureItem) {
        return this.getProperty.SmallPictureItem.Url;
      }
    }
    return '';
  }

  get propertyAddress() {
    if (this.getProperty) {
      return this.getAddress(this.getProperty);
    }
    return '';
  }

  get property() {
    if (this.getProperty) {
      return this.getProperty;
    }
    return {};
  }

  get coPropertyGoal() {
    if (this.getProperty) {
      return this.getProperty.Goal;
    }
    return -1;
  }

  private secretKey: string = '';
  private objectId: string = '';
  private isMobile: string = '';
  private appointmentId: string = '';
  private subject_mail = '';
  private email = '';
  private logo = '';
  private attach_mail = false;
  private showTermOfServices = true;

  private form = {
    AddressTitle: null,
    FirstName: '',
    Name: '',
    PhoneNumber: '',
    Email: '',
    // Content: '',
    IsReceivedEmail: false,
    roofs: [],
  };

  private roofsCheck = {
    EnoughMoney: true,
    MaxPerson: true,
    ReadDescription: true,
    NeedPay: true,
    custom1: false,
    custom2: false,
  };

  private formDisable = true;

  private AddressTitleOptions: { text: string, value: string | null }[] = [];

  get formLoading() {
    return this.getStatusSendFormLoading;
  }

  get formStatus() {
    return this.getStatusSendForm;
  }

  get formRoofs() {
    return this.form.roofs;
  }

  set formRoofs(val) {
    this.form.roofs = val;
    this.checkRoofs();
  }

  get appointment() {
    return this.getAppointmentByID(this.appointmentId) || null;
  }

  get appointmentTime() {
    const appointmentByID = this.getAppointmentByID(this.appointmentId);
    if (typeof appointmentByID !== 'undefined' && appointmentByID) {
      const appointment = deepClone(appointmentByID);
      const startTime = new Date(appointment.StartTime);
      const endTime = new Date(appointment.EndTime);
      appointment.ddStart = (startTime.getDate() < 10 ? '0' : '') + startTime.getDate();
      appointment.mmStart = ((startTime.getMonth() + 1) < 10 ? '0' : '') + (startTime.getMonth() + 1);
      appointment.yyyyStart = startTime.getFullYear();
      appointment.hoursStart = (startTime.getHours() < 10 ? '0' : '') + startTime.getHours();
      appointment.minStart = (startTime.getMinutes() < 10 ? '0' : '') + startTime.getMinutes();
      appointment.hoursEnd = (endTime.getHours() < 10 ? '0' : '') + endTime.getHours();
      appointment.minEnd = (endTime.getMinutes() < 10 ? '0' : '') + endTime.getMinutes();
      const time = `${appointment.ddStart}/${appointment.mmStart}/${appointment.yyyyStart} 
      ${this.$t('CONTACT_APPOINTMENT_FROM')} ${appointment.hoursStart}:${appointment.minStart} 
      ${this.$t('CONTACT_APPOINTMENT_TO')} ${appointment.hoursEnd}:${appointment.minEnd}`;
      return time;
    }
    return '';
  }

  get confirmEnoughMoney() {
    if (this.$route.query.confirmEnoughMoney && this.$route.query.confirmEnoughMoney !== 'undefined') {
      const str = this.$route.query.confirmEnoughMoney as string;
      return str.replace('{0}', this.getProperty.MinimumRevenue);
    }
    if (this.getProperty) {
      const str = this.$t('APPOINTMENT_CONFIRM_ENOUGH_MONEY') as string;
      return str.replace('{0}', parseFloat(this.getProperty.MinimumRevenue).toFixed(2));
    }
    return '';
  }

  get showConfirmEnoughMoney() {
    if (this.$route.query.showConfirmEnoughMoney && this.$route.query.showConfirmEnoughMoney === 'no') {
      this.roofsCheck.EnoughMoney = false;
      return false;
    }
    if (this.getProperty && this.getProperty.MinimumRevenue && this.getProperty.MinimumRevenue > 0) {
      this.roofsCheck.EnoughMoney = true;
      return true;
    }
    this.roofsCheck.EnoughMoney = false;
    return false;
  }

  get confirmRequestProof() {
    if (this.showConfirmRequestProof) {
      if (this.$route.query.confirmRequestProof && this.$route.query.confirmRequestProof !== 'undefined') {
        const str = this.$route.query.confirmRequestProof as string;
        return str;
      }
      const str = this.$t('APPOINTMENT_CONFIRM_REQUEST_PROOF') as string;
      return str;
    }
    return '';
  }

  get showConfirmRequestProof() {
    if (this.$route.query.showConfirmRequestProof && this.$route.query.showConfirmRequestProof === 'no') {
      return false;
    }
    return true;
  }

  get confirmMaxPerson() {
    if (this.$route.query.confirmMaxPerson && this.$route.query.confirmMaxPerson !== 'undefined') {
      const str = this.$route.query.confirmMaxPerson as string;
      return str.replace('{0}', this.getProperty.MaxNrPersons);
    }
    if (this.getProperty) {
      const str = this.$t('APPOINTMENT_CONFIRM_MAX_PERSON') as string;
      return str.replace('{0}', this.getProperty.MaxNrPersons);
    }
    return '';
  }

  get showConfirmMaxPerson() {
    if (this.$route.query.showConfirmMaxPerson && this.$route.query.showConfirmMaxPerson === 'no') {
      this.roofsCheck.MaxPerson = false;
      return false;
    }
    if (this.getProperty && this.getProperty.MaxNrPersons && this.getProperty.MaxNrPersons > 0) {
      this.roofsCheck.MaxPerson = true;
      return true;
    }
    this.roofsCheck.MaxPerson = false;
    return false;
  }

  get confirmReadDescription() {
    if (this.$route.query.confirmReadDescription && this.$route.query.confirmReadDescription !== 'undefined') {
      return this.$route.query.confirmReadDescription;
    }
    if (this.getProperty) {
      const str = this.$t('APPOINTMENT_CONFIRM_READ_DESCRIPTION') as string;
      return str;
    }
    return '';
  }

  get showConfirmReadDescription() {
    if (this.$route.query.showConfirmReadDescription && this.$route.query.showConfirmReadDescription === 'no') {
      this.roofsCheck.ReadDescription = false;
      return false;
    }
    if (this.getProperty) {
      this.roofsCheck.ReadDescription = true;
      return true;
    }
    this.roofsCheck.ReadDescription = false;
    return false;
  }

  get confirmNeedPay() {
    if (this.getProperty) {
      const data = this.getProperty;
      let rentGuarantee = 0;
      let total = 0;
      let text = '';

      if (this.$route.query.confirmNeedPayTotal && this.$route.query.confirmNeedPayTotal !== 'undefined') {
        text = this.$route.query.confirmNeedPayTotal as string;
      } else {
        text = this.$t('APPOINTMENT_CONFIRM_NEED_PAY_TOTAL') as string;
      }

      if (data.Price && data.Price > 0) {
        rentGuarantee = parseFloat(data.Price) * 3;
        total = total + parseFloat(data.Price) + rentGuarantee;
        if (this.$route.query.confirmNeedPayPrice && this.$route.query.confirmNeedPayPrice !== 'undefined') {
          text = text + (this.$route.query.confirmNeedPayPrice as string).replace('{0}', parseFloat(data.Price).toFixed(2));
        } else {
          text = text + (this.$t('APPOINTMENT_CONFIRM_NEED_PAY_PRICE') as string).replace('{0}', parseFloat(data.Price).toFixed(2));
        }
      }

      if (data.ChargesRenter && data.ChargesRenter > 0) {
        total = total + parseFloat(data.ChargesRenter);
        if (this.$route.query.confirmNeedPayChargesRenter && this.$route.query.confirmNeedPayChargesRenter !== 'undefined') {
          text = text + ', ' + (this.$route.query.confirmNeedPayChargesRenter as string).replace('{0}', parseFloat(data.ChargesRenter).toFixed(2));
        } else {
          text = text + ', ' + (this.$t('APPOINTMENT_CONFIRM_NEED_PAY_CHARGESRENTER') as string).replace('{0}', parseFloat(data.ChargesRenter).toFixed(2));
        }
      }

      if (data.RenterTotalCostVatInc && data.RenterTotalCostVatInc > 0) {
        total = total + parseFloat(data.RenterTotalCostVatInc);
        if (this.$route.query.confirmNeedPayTotalCost && this.$route.query.confirmNeedPayTotalCost !== 'undefined') {
          text = text + ', ' + (this.$route.query.confirmNeedPayTotalCost as string).replace('{0}', parseFloat(data.RenterTotalCostVatInc).toFixed(2));
        } else {
          text = text + ', ' + (this.$t('APPONTMENT_CONFIRM_NEED_PAY_RENTERTOTALCOST') as string).replace('{0}', parseFloat(data.RenterTotalCostVatInc).toFixed(2));
        }
      }

      if (data.Price && data.Price > 0) {
        if (this.$route.query.confirmNeedPayPriceX3 && this.$route.query.confirmNeedPayPriceX3 !== 'undefined') {
          text = text + ', ' + (this.$route.query.confirmNeedPayPriceX3 as string).replace('{0}', parseFloat(rentGuarantee.toString()).toFixed(2));
        } else {
          text = text + ', ' + (this.$t('APPONTMENT_CONFIRM_NEED_PAY_PRICEX3') as string).replace('{0}', parseFloat(rentGuarantee.toString()).toFixed(2));
        }
      }

      text = text.replace('{0}', parseFloat(total.toString()).toFixed(2));

      return text;
    }
    return '';
  }

  get showConfirmNeedPay() {
    if (this.$route.query.showConfirmNeedPay && this.$route.query.showConfirmNeedPay === 'no') {
      this.roofsCheck.NeedPay = false;
      return false;
    }
    if (this.getProperty && this.getProperty.Price && this.getProperty.Price > 0) {
      this.roofsCheck.NeedPay = true;
      return true;
    }
    this.roofsCheck.NeedPay = false;
    return false;
  }

  get conditionCustom1() {
    if (this.$route.query.conditionCustom1 && this.$route.query.conditionCustom1 !== '') {
      this.roofsCheck.custom1 = true;
      return this.$route.query.conditionCustom1 as string;
    } else {
      this.roofsCheck.custom1 = false;
      return '';
    }
  }

  get conditionCustom2() {
    if (this.$route.query.conditionCustom2 && this.$route.query.conditionCustom2 !== '') {
      this.roofsCheck.custom2 = true;
      return this.$route.query.conditionCustom2 as string;
    } else {
      this.roofsCheck.custom2 = false;
      return '';
    }
  }

  get isMobileView() {
    if (this.isMobile && this.isMobile === 'true') {
      return true;
    }
    return false;
  }

  get getConfirmTimeAppointment() {
    if (this.appointment) {
      let startDate = moment(this.appointment.StartTime).locale(this.$i18n.locale);
      let endDate = moment(this.appointment.EndTime).locale(this.$i18n.locale);
      return `${startDate.format('HH:mm')} - ${endDate.format('HH:mm')}, ${startDate.format('dddd, MMM D, YYYY')}`;
    }
  }

  get getDurationTimeAppointment() {
    if (this.appointment) {
      let startDate = moment(this.appointment.StartTime).locale(this.$i18n.locale);
      let endDate = moment(this.appointment.EndTime).locale(this.$i18n.locale);
      let duration = moment.duration(endDate.diff(startDate)).asMinutes();
      return duration + ' min';
    }
  }

  public mounted() {
    console.log('query: ', this.$route.query);
    this.subject_mail = this.$t('CONTACT_APPOINTMENT') as string;
    this.AddressTitleOptions = [
      { text: this.$t('TITLE') as string, value: null },
      { text: this.$t('MR') as string, value: 'MR' },
      { text: this.$t('MS') as string, value: 'MS' },
      { text: this.$t('MISS') as string, value: 'MISS' }
    ]
    this.secretKey = this.$route.query.key as string;
    this.objectId = this.$route.query.objectId as string;
    this.appointmentId = this.$route.query.appointmentId as string;
    this.email = this.$route.query.email as string;
    this.logo = this.$route.query.logo as string;
    this.isMobile = this.$route.query.isMobile as string;
    this.getAppointmentByObjectId({ objectId: this.objectId, key: this.secretKey });
    this.getPropertyAction({ objectId: this.objectId, key: this.secretKey })
      .then(res => {
        const { statusCode } = res;
        if (statusCode == 200) {
          if (res.data.GetPropertyJsonResult.Value.Goal == 1) { // if property forsale
            this.formDisable = true;
          } else {
            this.formDisable = false;
          }
        }
      });
  }

  public async onSubmit() {
    const vm = this as any;
    if (vm.$refs.form.reportValidity()) {
      this.sendContactAppointment({
        objectId: this.objectId,
        key: this.secretKey,
        email: this.email,
        data: this.prepareDataToSend()
      }).then((res) => {
        this.$router.push({
          name: 'confirm-appointment',
          query: {
            isSuccess: '1',
            propertyAddress: this.propertyAddress,
            appointmentDateTime: moment(this.appointment.StartTime).locale(this.$i18n.locale).format('dddd, MMM D, YYYY HH:mm'),
            ...this.$route.query
          }
        });
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  public checkRoofs() {
    // alert('check roofs');
    let error = 0;
    for (const confirm in this.roofsCheck) {
      if (this.roofsCheck.hasOwnProperty(confirm)) {
        // @ts-ignore
        const value: boolean = this.roofsCheck[confirm] as boolean;
        if (value) {
          const findCheck = this.form.roofs.filter(function (obj) { return obj === confirm });
          const inputCheck = document.getElementById(`input-group-${confirm}`);
          if (inputCheck && findCheck.length === 0) {
            inputCheck.setAttribute('style', 'background-color: yellow');
            setTimeout(function () {
              if (inputCheck) {
                inputCheck.setAttribute('style', 'background-color: transparent');
              }
            }, 1000);
            error++;
          }
        }
      }
    }
    if (error === 0) {
      this.showTermOfServices = false;
      this.formDisable = false;
    } else {
      this.showTermOfServices = true;
      this.formDisable = true;
    }
  }

  public prepareDataToSend() {
    const data = {
      ContactData: this.removeParamsNULL({
        Name: this.form.Name,
        FirstName: this.form.FirstName,
        AddressTitle: this.form.AddressTitle,
        Email: this.form.Email,
        PhoneNumber: this.form.PhoneNumber,
        // Content: this.form.Content,
        Subject: this.subject_mail,
        IsReceivedEmail: this.form.IsReceivedEmail,
        ObjectID: this.objectId,
        AppointmentID: this.appointmentId
      }),
      headers: {
        ReCaptchaResponse: '',
        UseCaptcha: false,
      },
      SendMail: {
        HtmlBody: this.compileMailToString().innerHTML
      }
    };
    return data;
  }

  public getAddress(prop: any) {
    let address: string = '';
    if (prop) {
      if (prop.PublishAddress === true) {
        address += prop.Street + ' ' + prop.HouseNumber;
      }

      if (address !== '') {
        address += ', ';
      }
      address += prop.Zip + ' ' + this.getCityAndCountry(prop.City, prop.CountryID, prop.CountryName);
    }
    return address;
  }

  public getCityAndCountry(city: string, countryID?: number, countryName?: string): string {
    let country = '';
    if (countryID && countryID !== 10) {
      if (countryName) {
        country = ` (${countryName})`;
      }
    }
    return city + country;
  }

  public compileMailToString() {
    return new ContactAppointmentMail({
      i18n: this.$i18n,
      propsData: {
        FIELD_SITE_LINK: '',
        LOGO: this.$route.query.logo,
        FIELD_SUBJECT: 'Appointment Online',
        FIELD_FIRSTNAME: this.form.FirstName,
        FIELD_NAME: this.form.Name,
        FIELD_PHONENUMBER: this.form.PhoneNumber,
        FIELD_EMAIL: this.form.Email,
        // FIELD_CONTENT: this.form.Content,

        FIELD_OBJECTID: this.property.ID,
        FIELD_PROPERTY_APPOINTMENT_TEXT: this.appointmentTime,
        FIELD_PROPERTY_GOAL: this.property.Goal,
        FIELD_PROPERTY_STREET: this.property.Street,
        FIELD_PROPERTY_HOUSENUMBER: this.property.HouseNumber,
        FIELD_PROPERTY_ZIP: this.property.Zip,
        FIELD_PROPERTY_CITY: this.property.City,
        FIELD_PROPERTY_TYPE: this.property.WebIDName,

        FIELD_SITE_ADDRESS_TITLE: this.form.AddressTitle,
        FIELD_SITE_STREET_HOUSENUMBER: '',
        FIELD_SITE_CITY_ZIP: '',
        FIELD_SITE_PHONE: '',
        FIELD_SITE_EMAIL: '',
        buttonBackColor: this.buttonBackColor,
        font: this.font
      }
    }).$mount().$el;
  }

  private removeParamsNULL(params: any) {
    const newParams: any = { ...params };
    for (const propName in newParams) {
      if (newParams[propName] === null || newParams[propName] === undefined || newParams[propName] === '' || newParams[propName] === 'none') {
        delete newParams[propName];
      }
    }
    return newParams;
  }
}
